export default "__VITE_PUBLIC_ASSET__623b08f3__"